import * as React from 'react';
import Header from '../Header/Header';
import StartReviewButtonContainer from '../StartReviewButton/StartReviewButtonContainer';
import DashboardContainer from '../DashboardReviews/DashboardReviewsContainer';
import ReviewsCountContainer from '../ReviewsCount/ReviewsCountContainer';
import HeaderLogo from '../HeaderLogo/HeaderLogo';
import EntitlementStatusContainer from '../EntitlementStatus/EntitlementStatusContainer';
import SettingsAndAccountWidget from '../SettingsAndAccountWidget/SettingsAndAccountWidget';
import NotificationsClientPluginWrapperContainer from '../NotificationsClientPluginWrapper/NotificationsClientPluginWrapperContainer';

export default ({canCreateReviews}: DashboardProps): any => {
   const headerLeft = (
      <React.Fragment>
         <StartReviewButtonContainer/>
         {false && canCreateReviews && <ReviewsCountContainer/>}
      </React.Fragment>
   );

   const headerMiddle = <HeaderLogo linkToRoot={false}/>;

   const headerRight = (
      <React.Fragment>
         <EntitlementStatusContainer/>
         <NotificationsClientPluginWrapperContainer/>
         <SettingsAndAccountWidget/>
      </React.Fragment>
   );

   return (
      <React.Fragment>
         <div className="home page">
            <Header leftSection={headerLeft} middleSection={headerMiddle} rightSection={headerRight}/>
            <DashboardContainer/>
         </div>
      </React.Fragment>
   );
};

export interface DashboardProps {
   canCreateReviews: boolean;
}
